import { AbstractHttp, ServiceMethod } from '@app/libs/services';
import { apiConfig } from '@app/repositories/config';

export class NotificationsService extends AbstractHttp {
  protected services = {
    registerDevice: {
      uri: '/me/notifications',
      method: 'POST' as ServiceMethod,
      host: '/',
      prefix: 'api',
      version: 'v1',
      authRequire: true,
      params: {
        fcmToken: { required: true },
      },
    },

    getNotifications: {
      uri: '/me/notifications',
      method: 'GET' as ServiceMethod,
      host: '/',
      prefix: 'api',
      version: 'v1',
      authRequire: true,
      params: {
        status: { required: false },
        isPriority: { required: false },
        orderBy: { required: false },
        pageIndex: { required: false },
        pageSize: { required: false },
      },
    },

    readNotification: {
      uri: '/me/notifications/{id}/read',
      method: 'POST' as ServiceMethod,
      host: '/',
      prefix: 'api',
      version: 'v1',
      authRequire: true,
      params: {
        id: { required: true },
      },
    },

    readAllNotifications: {
      uri: '/me/notifications/read',
      method: 'POST' as ServiceMethod,
      host: '/',
      prefix: 'api',
      version: 'v1',
      authRequire: true,
    },

    testNotification: {
      uri: '/me/notifications',
      method: 'PUT' as ServiceMethod,
      host: '/',
      prefix: 'api',
      version: 'v1',
      authRequire: true,
      params: {
        title: { required: true },
        message: { required: true },
      },
    },
  };

  registerDevice(fcmToken: string) {
    return this.send('registerDevice', { params: { fcmToken } });
  }

  testNotification(title: string, message: string) {
    return this.send('testNotification', { params: { title, message } });
  }

  listNotifications(params?: {
    status?: string;
    isPriority?: boolean;
    orderBy?: string[];
    pageIndex?: number;
    pageSize?: number;
  }) {
    return this.send('getNotifications', { params });
  }

  getNotifications(status?: 'unread' | 'read' | 'all', pageIndex?: number, pageSize?: number) {
    status = status === 'all' ? undefined : status;
    return this.listNotifications({
      status,
      pageIndex,
      pageSize,
      orderBy: ['createdAt:desc'],
      isPriority: true,
    });
  }

  readNotification(id: string) {
    return this.send('readNotification', { params: { id } });
  }

  readAllNotifications() {
    return this.send('readAllNotifications', {});
  }
}

export const notificationsService = new NotificationsService();
